// Shared engine for the hand-built calendar grids (desktop + mobile web).
// The React Native app mirrors these same constants/helpers — keep values in
// sync across all three surfaces so the calendars behave identically.

export const HOUR_START = 7; // 7 AM
export const HOUR_END = 21; // 9 PM
export const TOTAL_HOURS = HOUR_END - HOUR_START;
export const SLOT_MINUTES = 15;
export const PX_PER_MIN = 3; // 3px per minute → 1 hour = 180px, 15min = 45px
export const PX_PER_HOUR = 60 * PX_PER_MIN;
export const TOTAL_HEIGHT = TOTAL_HOURS * PX_PER_HOUR;
export const GUTTER_WIDTH = 52;
export const SNAP_MINUTES = 5; // snap to 5-min increments when dragging
export const SNAP_PX = SNAP_MINUTES * PX_PER_MIN;

export const BARBER_COLORS = [
  {
    bg: "#E6F1FB",
    border: "#378ADD",
    dot: "#378ADD",
    text: "#0C447C",
    soft: "#F4F9FE",
  },
  {
    bg: "#FAEEDA",
    border: "#EF9F27",
    dot: "#EF9F27",
    text: "#854F0B",
    soft: "#FDF8EF",
  },
  {
    bg: "#FCEBEB",
    border: "#E24B4A",
    dot: "#E24B4A",
    text: "#A32D2D",
    soft: "#FDF6F6",
  },
  {
    bg: "#EEEDFE",
    border: "#7F77DD",
    dot: "#7F77DD",
    text: "#3C3489",
    soft: "#F8F7FE",
  },
  {
    bg: "#E1F5EE",
    border: "#1D9E75",
    dot: "#1D9E75",
    text: "#0F6E56",
    soft: "#F2FAF7",
  },
  {
    bg: "#FBEAF0",
    border: "#D4537E",
    dot: "#D4537E",
    text: "#72243E",
    soft: "#FDF6F9",
  },
];

export const STATUS_STYLES = {
  pending: { bg: "#FAEEDA", text: "#854F0B", label: "Pending" },
  confirmed: { bg: "#E6F1FB", text: "#0C447C", label: "Confirmed" },
  completed: { bg: "#E1F5EE", text: "#0F6E56", label: "Completed" },
  cancelled: { bg: "#FCEBEB", text: "#A32D2D", label: "Cancelled" },
  no_show: { bg: "#F1EFE8", text: "#5F5E5A", label: "No-show" },
};

export const STATUS_DOTS = {
  pending: "#EF9F27",
  confirmed: "#378ADD",
  completed: "#1D9E75",
  cancelled: "#E24B4A",
  no_show: "#9b9b9b",
};

export const REASON_LABELS = {
  lunch: "🍽 Lunch",
  break: "☕ Break",
  vacation: "🏖 Vacation",
  sick_day: "🤒 Sick day",
  personal: "Personal",
  other: "Blocked",
};

// Statuses that lock a booking in place on the grid
export const isBookingLocked = (status) =>
  ["completed", "cancelled", "no_show"].includes(status);

// Convert a Date to px offset from top of grid
export const dateToPx = (date) => {
  const h = date.getHours();
  const m = date.getMinutes();
  return ((h - HOUR_START) * 60 + m) * PX_PER_MIN;
};

// Convert a px offset to a Date on a given calendar date (snapped)
export const pxToDate = (px, baseDate) => {
  const totalMinutes = Math.round(px / PX_PER_MIN);
  const snapped = Math.round(totalMinutes / SNAP_MINUTES) * SNAP_MINUTES;
  const h = HOUR_START + Math.floor(snapped / 60);
  const m = snapped % 60;
  const d = new Date(baseDate);
  d.setHours(h, m, 0, 0);
  return d;
};

export const snapPx = (px) => Math.round(px / SNAP_PX) * SNAP_PX;
